import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { IFrom } from '@/types/achievement';
import api from '@/api/achievement';


@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '配置 - 模态框 -',
    component: 'set/components/bModal',
  };

  public form: IFrom = {
    medalTitle: '',
    typePid: '',
    medalDescription: '',
    medalFunction: '',
    medalScore: '',
    medalImage: '',
    activeTag: '',
    execuSqlNo: '',
    accessCondition: ''
  }

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    key: [
      { required: true, message: '配置不能为空' },
    ],
    value: [
      { required: true, message: '配置值不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑')) {
          api.editAchievement(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addAchievement(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
